import React from 'react';

import BreakdownAlert from 'shared/components/Breakdown/BreakdownAlert/BreakdownAlert';
import BreakdownColumn from 'shared/components/Breakdown/BreakdownColumn/BreakdownColumn';
import BreakdownContent from 'shared/components/Breakdown/BreakdownContent/BreakdownContent';
import BreakdownExpandableContainer from 'shared/components/Breakdown/BreakdownExpandableContainer/BreakdownExpandableContainer';
import BreakdownImportantMessage from 'shared/components/Breakdown/BreakdownImportantMessage/BreakdownImportantMessage';
import BreakdownInfoTable from 'shared/components/Breakdown/BreakdownInfoTable/BreakdownInfoTable';
import BreakdownMessage from 'shared/components/Breakdown/BreakdownMessage/BreakdownMessage';
import BreakdownRecipients from 'shared/components/Breakdown/BreakdownRecipients/BreakdownRecipients';
import BreakdownRow from 'shared/components/Breakdown/BreakdownRow/BreakdownRow';
import BreakdownSection from 'shared/components/Breakdown/BreakdownSection/BreakdownSection';
import BreakdownSectionTitle from 'shared/components/Breakdown/BreakdownSectionTitle/BreakdownSectionTitle';
import BreakdownText from 'shared/components/Breakdown/BreakdownText/BreakdownText';
import BreakdownTitle from 'shared/components/Breakdown/BreakdownTitle/BreakdownTitle';

class Breakdown extends React.PureComponent {
  public static Title = BreakdownTitle;
  public static Message = BreakdownMessage;
  public static Content = BreakdownContent;
  public static Section = BreakdownSection;
  public static SectionTitle = BreakdownSectionTitle;
  public static Text = BreakdownText;
  public static Row = BreakdownRow;
  public static Column = BreakdownColumn;
  public static InfoTable = BreakdownInfoTable;
  public static ExpandableContainer = BreakdownExpandableContainer;
  public static Recipients = BreakdownRecipients;
  public static ImportantMessage = BreakdownImportantMessage;
  public static Alert = BreakdownAlert;
}

export default Breakdown;
